import { Show, createEffect, onCleanup } from "solid-js";
import { styles } from "../styles";

export interface SendFailureTarget {
  operation: string;
  message: string;
  response: string;
}

interface Props {
  target: SendFailureTarget | null;
  remaining: number;
  onClose: () => void;
}

export function SendFailureModal(props: Props) {
  let closeButton!: HTMLButtonElement;

  createEffect(() => {
    if (props.target) queueMicrotask(() => closeButton?.focus());
  });

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === "Escape" && props.target) props.onClose();
  };
  window.addEventListener("keydown", onKeyDown);
  onCleanup(() => window.removeEventListener("keydown", onKeyDown));

  return (
    <Show when={props.target}>
      {(target) => (
        <div class={styles.sendFailureLayer} role="presentation">
          <button class={styles.previewBackdrop} type="button" aria-label="送信エラーを閉じる" onClick={props.onClose} />
          <section class={styles.sendFailureModal} role="alertdialog" aria-modal="true" aria-labelledby="send-failure-title">
            <header class={styles.previewHeader}>
              <h2 id="send-failure-title">送信に失敗しました</h2>
              <button ref={closeButton} class={styles.iconButton} type="button" aria-label="閉じる" onClick={props.onClose}>×</button>
            </header>
            <div class={styles.sendFailureBody}>
              <dl class={styles.sendFailureDetails}>
                <div>
                  <dt>失敗した処理</dt>
                  <dd>{target().operation}</dd>
                </div>
                <div>
                  <dt>エラー内容</dt>
                  <dd>{target().message}</dd>
                </div>
                <div>
                  <dt>返却内容</dt>
                  <dd><pre class={styles.sendFailureResponse}>{target().response}</pre></dd>
                </div>
              </dl>
              <Show when={props.remaining > 0}>
                <p class={styles.sendFailureRemaining}>ほかに{props.remaining}件の送信エラーがあります。</p>
              </Show>
              <div class={styles.qrRegistrationActions}>
                <button class={styles.secondaryButton} type="button" onClick={props.onClose}>
                  {props.remaining > 0 ? "次のエラーを表示" : "閉じる"}
                </button>
              </div>
            </div>
          </section>
        </div>
      )}
    </Show>
  );
}
